module.exports = __webpack_public_path__ + "img/ywAward-b.375753a6.png";